import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section id="download" className="py-16 md:py-20 bg-background-50 relative overflow-hidden">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto relative z-10">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 text-balance">
            立即下载<span className="text-primary-500">51漫画</span>APP
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
            随时随地畅享海量免费漫画，支持离线下载、夜间模式、智能推荐等多种功能
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
            <Link
              to="#"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-android-line w-5 h-5 flex items-center justify-center"></i>
              Android 下载
            </Link>
            <Link
              to="#"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-foreground-200 text-foreground-700 font-semibold text-sm hover:bg-foreground-50 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-apple-line w-5 h-5 flex items-center justify-center"></i>
              iOS 下载
            </Link>
          </div>
          <p className="mt-6 text-xs text-foreground-400">
            也可直接访问 <a href="#" className="text-primary-500 hover:underline">51漫画网页版</a> 在线观看
          </p>
        </div>
      </div>

      <div className="mt-12 relative w-full h-48 md:h-64 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Horizontal%20banner%20illustration%20featuring%20various%20Chinese%20manhua%20character%20silhouettes%20in%20dynamic%20poses%20arranged%20across%20a%20wide%20composition%2C%20warm%20red%20and%20orange%20gradient%20background%2C%20comic-style%20decorative%20elements%2C%20action%20lines%2C%20vibrant%20energetic%20feel%2C%20digital%20art%20style%2C%20clean%20horizontal%20layout%20with%20characters%20popping%20from%20edges&width=1920&height=400&seq=cta-banner&orientation=landscape"
          alt="51漫画角色集合"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
      </div>
    </section>
  );
}